export const TOGGLE_ON_MAIN_SITE_DROPDOWN = "TOGGLE_ON_MAIN_SITE_DROPDOWN";
export const TOGGLE_ON_COMPARE_DROPDOWN = "TOGGLE_ON_COMPARE_DROPDOWN";
export const TOGGLE_OFF_COMPARE_DROPDOWN = "TOGGLE_OFF_COMPARE_DROPDOWN";
export const TOGGLE_ON_PERSISTENT_QUERY_BAR = "TOGGLE_ON_PERSISTENT_QUERY_BAR";
export const SHOW_QUERY_BAR_TOOLTIP = "SHOW_QUERY_BAR_TOOLTIP";
export const HIDE_QUERY_BAR_TOOLTIP = "HIDE_QUERY_BAR_TOOLTIP";
